<template>
    <Pembayaran jenisPembayaran="PL"/>
</template>

<script>

import Pembayaran from '../../components/pembayaran/Pembayaran'

export default {
    name: 'pelunasan-pembayaran',
    components: {
        Pembayaran,
    }
}
</script>